var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloseFilterBar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dabas-Search-UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-&-Explore---Filter---Ingredients",
    transform: "translate(-284.000000, -30.000000)",
    fill: "#0B3358",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(284.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8924845,5 L-0.182807127,5 C-0.633906232,5 -1,5.45000315 -1,6 C-1,6.54999685 -0.633906232,7 -0.182807127,7 L12.8924845,7 C13.3419381,7 13.7096774,6.54999685 13.7096774,6 C13.7096774,5.45000315 13.3419381,5 12.8924845,5 Z",
    id: "Path",
    transform: "translate(6.354839, 6.000000) rotate(-45.000000) translate(-6.354839, -6.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8924845,5 L-0.182807127,5 C-0.633906232,5 -1,5.45000315 -1,6 C-1,6.54999685 -0.633906232,7 -0.182807127,7 L12.8924845,7 C13.3419381,7 13.7096774,6.54999685 13.7096774,6 C13.7096774,5.45000315 13.3419381,5 12.8924845,5 Z",
    id: "Path",
    transform: "translate(6.354839, 6.000000) rotate(-315.000000) translate(-6.354839, -6.000000) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseFilterBar);
export default __webpack_public_path__ + "static/media/close-filter-bar.699230eb896f4425cdb9156279d4a9e4.svg";
export { ForwardRef as ReactComponent };